<template>
  <v-tabs v-if="$vuetify.breakpoint.smAndDown"
          right
          :mandatory="false"
          hide-slider
          color="transparent">
    <v-tab v-for="(tab_item) in mobileTabs.main" 
          :key="`${href}${tab_item.name}`"
          :to="{path:`${href}${tab_item.name}`}"
          :class="{ 'mobile-active-tab': currentTab === tab_item.name }"
    >{{tab_item.label}}</v-tab>

    
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-tab
            color="primary"
            v-on="on"
            :class="{ 'mobile-active-tab': moreTabName }"
          >
            {{moreTabName || "More"}} <v-icon>expand_more</v-icon>
          </v-tab>
        </template>
        <v-list style="max-height: 60vh; overflow-x: scroll;">
          <v-list-tile
            v-for="(tab_item) in mobileTabs.more"
            :key="`${href}${tab_item.name}`"
            :to="{path:`${href}${tab_item.name}`}"
          >
            <v-list-tile-title>{{ tab_item.label }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
  </v-tabs>



  <v-tabs v-else
          align-with-title
          right
          :mandatory="false"
          show-arrows
          color="transparent">
    <v-tab v-for="(tab_item) in tab_list" 
          v-show="tab_item.visible"
          :key="`${href}${tab_item.name}`"
          :to="{path:`${href}${tab_item.name}`}"
          :class="{ 'v-tabs__item--active': currentTab === tab_item.name }"
        >{{tab_item.label}}</v-tab>
  </v-tabs>

</template>

<script>
export default {
  name: 'tabs',
  props: {
    /** tab_item: { name: 'children',  label: 'Children', count: true, dataRequired: 'obj_key' }  */
    tab_list: {type: Array, required: true, default: () => []},
    href: { type: String, required: true },
    inputData: { type: Object, default: () => {} },
    currentTab: { type: String, required: true},
    visible: { type: Boolean, required: false }
  },
  data() {
    return {
      active: 2
    }
  },
  computed: {
    moreTabName() {
      const tab = _.find(this.mobileTabs.more, {name: this.currentTab});
      if (tab) return tab.label;
    },
    mobileTabs() {
      return {
        main: this.tab_list.slice(0, 2),
        more: this.tab_list.slice(2),
      }
    }
  },
  created() {
    this.renderTabs()
  },
  watch: {
    inputData: {
      handler: function  (value) {
        this.renderTabs()
      },
      deep: true
    },
    tab_list: function  () {
      this.renderTabs()
    },
  },
  methods: {
    renderTabs() {
      this.tab_list.forEach((tab) => {
        if (!tab.hasOwnProperty('showTab')) {
          tab.showTab = true
        }

        this.$set(tab, 'visible', tab.showTab && (!tab.dataRequired || !_.isEmpty(this.inputData[tab.name])))

      })
    }
  }

}
</script>

<style scoped>
.mobile-active-tab {
  border-bottom: 2px solid #82b1ff;
}
</style>



// WEBPACK FOOTER //
// src/components/materialTabs.vue